import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function MemberManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    photo: '',
    fullName: '',
    fatherName: '',
    spouseName: '',
    nid: '',
    birthCertNo: '',
    profession: '',
    age: '',
    education: '',
    division: '',
    district: '',
    upazila: '',
    union: '',
    village: '',
    range: '',
    station: '',
    bloodGroup: '',
    nidAttachment: '',
    birthCertAttachment: '',
    educationAttachment: ''
  });
  const stationsByRange: Record<string, string[]> = {
    Satkhira: ['Burigoalini Station', 'Kaikhali Station', 'Dobeki Station'],
    Khulna: ['Nalian Station', 'Patkosta Station', 'Karamjal Station'],
    Chandpai: ['Harbaria Station', 'Joymoni Station', 'Tamulbunia Station'],
    Sarankhola: ['Supati Station', 'Sharankhola Station', 'Kotka Station']
  };
  const members = [{
    photo: '👤',
    name: 'Abdur Rahman',
    email: 'abdur@member.com',
    idNumber: 'MBR-001',
    phone: '01711111111',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Jalal Uddin',
    email: 'jalal@member.com',
    idNumber: 'MBR-002',
    phone: '01822222222',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Rina Begum',
    email: 'rina@member.com',
    idNumber: 'MBR-003',
    phone: '01933333333',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Kamrul Hasan',
    email: 'kamrul@member.com',
    idNumber: 'MBR-004',
    phone: '01644444444',
    status: 'pending' as const
  }, {
    photo: '👤',
    name: 'Shirin Akter',
    email: 'shirin@member.com',
    idNumber: 'MBR-005',
    phone: '01555555555',
    status: 'approved' as const
  }];
  const columns = [{
    key: 'photo',
    label: 'Photo',
    render: (value: string) => <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xl" data-id="element-1009">
          {value}
        </div>
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1010" />
  }];
  const filters = [{
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Personal Info',
    description: 'Enter member personal information'
  }, {
    title: 'Address Details',
    description: 'Enter address details'
  }, {
    title: 'Documents',
    description: 'Upload required documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-1011">
      <div data-id="element-1012">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1013">Member Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1014">
          Manage conservation group members
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-1015">
        <div className="flex gap-4" data-id="element-1016">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1017">
            Member List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1018">
            Add Member
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={members} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search members..." data-id="element-1019" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.nid) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Member ${formData.fullName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        photo: '',
        fullName: '',
        fatherName: '',
        spouseName: '',
        nid: '',
        birthCertNo: '',
        profession: '',
        age: '',
        education: '',
        division: '',
        district: '',
        upazila: '',
        union: '',
        village: '',
        range: '',
        station: '',
        bloodGroup: '',
        nidAttachment: '',
        birthCertAttachment: '',
        educationAttachment: ''
      });
    }} data-id="element-1020">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1021">
              <div className="grid grid-cols-2 gap-4" data-id="element-1022">
                <div data-id="element-1023">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1024">
                    Photo Upload
                  </label>
                  <input type="file" accept="image/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1025" />
                </div>
                <div data-id="element-1026">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1027">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1028" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1029">
                <div data-id="element-1030">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1031">
                    Father's Name
                  </label>
                  <input type="text" value={formData.fatherName} onChange={e => setFormData({
              ...formData,
              fatherName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1032" />
                </div>
                <div data-id="element-1033">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1034">
                    Spouse Name
                  </label>
                  <input type="text" value={formData.spouseName} onChange={e => setFormData({
              ...formData,
              spouseName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1035" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1036">
                <div data-id="element-1037">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1038">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1039" />
                </div>
                <div data-id="element-1040">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1041">
                    Birth Certificate No.
                  </label>
                  <input type="text" value={formData.birthCertNo} onChange={e => setFormData({
              ...formData,
              birthCertNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1042" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-1043">
                <div data-id="element-1044">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1045">
                    Profession
                  </label>
                  <input type="text" value={formData.profession} onChange={e => setFormData({
              ...formData,
              profession: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1046" />
                </div>
                <div data-id="element-1047">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1048">
                    Age
                  </label>
                  <input type="number" value={formData.age} onChange={e => setFormData({
              ...formData,
              age: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1049" />
                </div>
                <div data-id="element-1050">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1051">
                    Education
                  </label>
                  <input type="text" value={formData.education} onChange={e => setFormData({
              ...formData,
              education: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1052" />
                </div>
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-1053">
              <div className="grid grid-cols-2 gap-4" data-id="element-1054">
                <div data-id="element-1055">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1056">
                    Division
                  </label>
                  <select value={formData.division} onChange={e => setFormData({
              ...formData,
              division: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1057">
                    <option value="" data-id="element-1058">Select Division</option>
                    <option value="Khulna" data-id="element-1059">Khulna</option>
                    <option value="Barisal" data-id="element-1060">Barisal</option>
                    <option value="Dhaka" data-id="element-1061">Dhaka</option>
                    <option value="Chattogram" data-id="element-1062">Chattogram</option>
                    <option value="Rajshahi" data-id="element-1063">Rajshahi</option>
                    <option value="Rangpur" data-id="element-1064">Rangpur</option>
                    <option value="Sylhet" data-id="element-1065">Sylhet</option>
                    <option value="Mymensingh" data-id="element-1066">Mymensingh</option>
                  </select>
                </div>
                <div data-id="element-1067">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1068">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1069">
                    <option value="" data-id="element-1070">Select District</option>
                    <option value="Satkhira" data-id="element-1071">Satkhira</option>
                    <option value="Khulna" data-id="element-1072">Khulna</option>
                    <option value="Bagerhat" data-id="element-1073">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1074">
                <div data-id="element-1075">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1076">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1077">
                    <option value="" data-id="element-1078">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-1079">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1080">Koyra</option>
                    <option value="Dacope" data-id="element-1081">Dacope</option>
                    <option value="Mongla" data-id="element-1082">Mongla</option>
                    <option value="Sarankhola" data-id="element-1083">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-1084">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1085">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1086">
                    <option value="" data-id="element-1087">Select Union</option>
                    <option value="Burigoalini" data-id="element-1088">Burigoalini</option>
                    <option value="Gabura" data-id="element-1089">Gabura</option>
                    <option value="Munshiganj" data-id="element-1090">Munshiganj</option>
                    <option value="Koyra" data-id="element-1091">Koyra</option>
                    <option value="Dacope" data-id="element-1092">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1093">
                <div data-id="element-1094">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1095">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1096">
                    <option value="" data-id="element-1097">Select Village</option>
                    <option value="Munshiganj" data-id="element-1098">Munshiganj</option>
                    <option value="Gabura" data-id="element-1099">Gabura</option>
                    <option value="Shyamnagar" data-id="element-1100">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1101">Koyra</option>
                    <option value="Dacope" data-id="element-1102">Dacope</option>
                  </select>
                </div>
                <div data-id="element-1103">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1104">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value,
              station: ''
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1105">
                    <option value="" data-id="element-1106">Select Range</option>
                    <option value="Satkhira" data-id="element-1107">Satkhira</option>
                    <option value="Khulna" data-id="element-1108">Khulna</option>
                    <option value="Chandpai" data-id="element-1109">Chandpai</option>
                    <option value="Sarankhola" data-id="element-1110">Sarankhola</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1111">
                <div data-id="element-1112">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1113">
                    Station
                  </label>
                  <select value={formData.station} onChange={e => setFormData({
              ...formData,
              station: e.target.value
            })} disabled={!formData.range} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:bg-gray-100 disabled:text-gray-400" data-id="element-1114">
                    <option value="" data-id="element-1115">
                      {formData.range ? 'Select Station' : 'Select Range first'}
                    </option>
                    {formData.range && stationsByRange[formData.range]?.map(station => <option key={station} value={station} data-id="element-1116">
                          {station}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-1117">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1118">
                    Blood Group
                  </label>
                  <select value={formData.bloodGroup} onChange={e => setFormData({
              ...formData,
              bloodGroup: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1119">
                    <option value="" data-id="element-1120">Select Blood Group</option>
                    <option value="A+" data-id="element-1121">A+</option>
                    <option value="A-" data-id="element-1122">A-</option>
                    <option value="B+" data-id="element-1123">B+</option>
                    <option value="B-" data-id="element-1124">B-</option>
                    <option value="AB+" data-id="element-1125">AB+</option>
                    <option value="AB-" data-id="element-1126">AB-</option>
                    <option value="O+" data-id="element-1127">O+</option>
                    <option value="O-" data-id="element-1128">O-</option>
                  </select>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1129">
              <div data-id="element-1130">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1131">
                  NID Copy *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1132" />
              </div>
              <div data-id="element-1133">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1134">
                  Birth Certificate Copy
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1135" />
              </div>
              <div data-id="element-1136">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1137">
                  Education Certificate
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1138" />
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-1139">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1140">
                <div className="flex items-center justify-between mb-3" data-id="element-1141">
                  <h4 className="font-semibold text-gray-900" data-id="element-1142">
                    Personal Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1143">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1144">
                  <div data-id="element-1145">
                    <span className="text-gray-600" data-id="element-1146">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1147">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1148">
                    <span className="text-gray-600" data-id="element-1149">NID:</span>{' '}
                    <span className="font-medium" data-id="element-1150">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1151">
                    <span className="text-gray-600" data-id="element-1152">Profession:</span>{' '}
                    <span className="font-medium" data-id="element-1153">
                      {formData.profession || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1154">
                <div className="flex items-center justify-between mb-3" data-id="element-1155">
                  <h4 className="font-semibold text-gray-900" data-id="element-1156">
                    Address Details
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1157">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1158">
                  <div data-id="element-1159">
                    <span className="text-gray-600" data-id="element-1160">Division:</span>{' '}
                    <span className="font-medium" data-id="element-1161">
                      {formData.division || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1162">
                    <span className="text-gray-600" data-id="element-1163">District:</span>{' '}
                    <span className="font-medium" data-id="element-1164">
                      {formData.district || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1165">
                    <span className="text-gray-600" data-id="element-1166">Upazila:</span>{' '}
                    <span className="font-medium" data-id="element-1167">
                      {formData.upazila || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1168">
                    <span className="text-gray-600" data-id="element-1169">Union:</span>{' '}
                    <span className="font-medium" data-id="element-1170">
                      {formData.union || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1171">
                    <span className="text-gray-600" data-id="element-1172">Village:</span>{' '}
                    <span className="font-medium" data-id="element-1173">
                      {formData.village || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1174">
                    <span className="text-gray-600" data-id="element-1175">Range:</span>{' '}
                    <span className="font-medium" data-id="element-1176">
                      {formData.range || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1177">
                    <span className="text-gray-600" data-id="element-1178">Station:</span>{' '}
                    <span className="font-medium" data-id="element-1179">
                      {formData.station || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}